module.exports = __webpack_public_path__ + "img/montage_header.1da654fd.webp";